import apiClient from "services/axios";

const API = {
  list: "/api/v1/widget-channel-states",
  create: "/api/v1/widget-channel-states",
  detail: "/api/v1/widget-channel-states",
  update: "/api/v1/widget-channel-states",
  delete: "/api/v1/widget-channel-states",
};

export const list = async (filter) => {
  const response = await apiClient.get(API.list, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const create = async (body) => {
  const response = await apiClient.post(API.create, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (response) {
    return response.data;
  }
  return false;
};

export const detail = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const update = async (id, body) => {
  const response = await apiClient.patch(`${API.update}/${id}`, body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (response) {
    return response.data;
  }
  return false;
};

export const remove = async (id) => {
  const response = await apiClient.delete(`${API.delete}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};
